 
//confirm script has been loaded from tag name reference in theme.liquid
console.log("interchange javascript loaded!");

  //Get submit btn as var and load css class to display minimums message
  var submitBtn = document.getElementById('addToCart-product-character-grid');
  submitBtn.classList.add("minimums");
  submitBtn.innerText = "";

//waitForElement function definition

  function waitForElement(id, callback){
var waitTimer = setInterval(function(){
    if(document.getElementById(id)){
        clearInterval(waitTimer);
        callback();
    }
}, 500);
}

      console.log("Character Selection Table Activated");
    submitBtn.disabled = true;
    submitBtn.innerText = "";
    submitBtn.classList.add("minimums");
    submitBtn.style.backgroundColor="red";
    console.log("submit button disabled");

//wait for character height
waitForElement("option_6917275025495_charHeight", function(){                 

const Height = document.getElementById("option_6917275025495_charHeight").addEventListener('change', heightChange);

function heightChange(event) {
    //redefine values from input fields    
let charA = parseInt(document.getElementById('option_6917275025495_A').value) || 0;
let charB = parseInt(document.getElementById('option_6917275025495_B').value) || 0;
let charC = parseInt(document.getElementById('option_6917275025495_C').value) || 0;
let charD = parseInt(document.getElementById('option_6917275025495_D').value) || 0;
let charE = parseInt(document.getElementById('option_6917275025495_E').value) || 0;
let charF = parseInt(document.getElementById('option_6917275025495_F').value) || 0;
let charG = parseInt(document.getElementById('option_6917275025495_G').value) || 0;
let charH = parseInt(document.getElementById('option_6917275025495_H').value) || 0;
let charI = parseInt(document.getElementById('option_6917275025495_I').value) || 0;
let charJ = parseInt(document.getElementById('option_6917275025495_J').value) || 0;
let charK = parseInt(document.getElementById('option_6917275025495_K').value) || 0;
let charL = parseInt(document.getElementById('option_6917275025495_L').value) || 0;
let charM = parseInt(document.getElementById('option_6917275025495_M').value) || 0;
let charN = parseInt(document.getElementById('option_6917275025495_N').value) || 0;
let charO = parseInt(document.getElementById('option_6917275025495_O').value) || 0;
let charP = parseInt(document.getElementById('option_6917275025495_P').value) || 0;
let charQ = parseInt(document.getElementById('option_6917275025495_Q').value) || 0;
let charR = parseInt(document.getElementById('option_6917275025495_R').value) || 0;
let charS = parseInt(document.getElementById('option_6917275025495_S').value) || 0;
let charT = parseInt(document.getElementById('option_6917275025495_T').value) || 0;
let charU = parseInt(document.getElementById('option_6917275025495_U').value) || 0;
let charV = parseInt(document.getElementById('option_6917275025495_V').value) || 0;
let charW = parseInt(document.getElementById('option_6917275025495_W').value) || 0;
let charX = parseInt(document.getElementById('option_6917275025495_X').value) || 0;
let charY = parseInt(document.getElementById('option_6917275025495_Y').value) || 0;
let charZ = parseInt(document.getElementById('option_6917275025495_Z').value) || 0;
let char0 = parseInt(document.getElementById('option_6917275025495_0').value) || 0;
let char1 = parseInt(document.getElementById('option_6917275025495_1').value) || 0;
let char2 = parseInt(document.getElementById('option_6917275025495_2').value) || 0;
let char3 = parseInt(document.getElementById('option_6917275025495_3').value) || 0;
let char4 = parseInt(document.getElementById('option_6917275025495_4').value) || 0;
let char5 = parseInt(document.getElementById('option_6917275025495_5').value) || 0;
let char6 = parseInt(document.getElementById('option_6917275025495_6').value) || 0;
let char7 = parseInt(document.getElementById('option_6917275025495_7').value) || 0;
let char8 = parseInt(document.getElementById('option_6917275025495_8').value) || 0;
let char9 = parseInt(document.getElementById('option_6917275025495_9').value) || 0;
let charPeriod = parseInt(document.getElementById('option_6917275025495_Period').value) || 0;
let charComma = parseInt(document.getElementById('option_6917275025495_Comma').value) || 0;
let charDash = parseInt(document.getElementById('option_6917275025495_Dash').value) || 0;
let charSlash = parseInt(document.getElementById('option_6917275025495_Slash').value) || 0;
let charAmpersand = parseInt(document.getElementById('option_6917275025495_Ampersand').value) || 0;
let charSpacer = parseInt(document.getElementById('option_6917275025495_Spacer').value) || 0;

      
let totalCount = charA + charB + charC + charD + charE + charF + charG +
  charH + charI + charJ + charK + charL + charM + charN + charO + charP +
  charQ + charR + charS + charT + charU + charV + charW + charX + charY +
  charZ + char0 + char1 + char2 + char3 + char4 + char5 + char6 + char7 +
  char8 + char9 + charPeriod + charComma + charDash + charSlash + charAmpersand + charSpacer;
var charHeight = document.getElementById("option_6917275025495_charHeight").value;
  if (charHeight == "3/8 (10mm)") {
    var submitBtn = document.getElementById('addToCart-product-character-grid');
  submitBtn.classList.add("fiveminimums");
    submitBtn.classList.remove("minimums");
        
  if ((charA < 5 && charA>0) || (charB < 5 && charB>0) || (charC < 5 && charC>0) || (charD < 5 && charD>0) || (charE < 5 && charE>0) || (charF < 5 && charF>0) || (charG < 5 && charG>0) || (charH < 5 && charH>0)
     || (charI < 5 && charI>0) || (charJ < 5 && charJ>0) || (charK < 5 && charK>0) || (charL < 5 && charL>0) || (charM < 5 && charM>0) || (charN < 5 && charN>0) || (charO < 5 && charO>0) || (charP < 5 && charP>0)
     || (charQ < 5 && charQ>0) || (charR < 5 && charR>0) || (charS < 5 && charS>0) || (charT < 5 && charT>0) || (charU < 5 && charU>0) || (charV < 5 && charV>0) || (charW < 5 && charW>0) || (charX < 5 && charX>0)
     || (charY < 5 && charY>0) || (charZ < 5 && charZ>0) || (char0 < 5 && char0>0) || (char1 < 5 && char1>0) || (char2 < 5 && char2>0) || (char3 < 5 && char3>0) || (char4 < 5 && char4>0) || (char5 < 5 && char5>0)
     || (char6 < 5 && char6>0) || (char7 < 5 && char7>0) || (char8 < 5 && char8>0) || (char9 < 5 && char9>0) || (charPeriod < 5 && charPeriod>0) || (charComma < 5 && charComma>0) || (charDash < 5 && charDash>0)
     || (charSlash < 5 && charSlash>0) || (charAmpersand < 5 && charAmpersand>0) || (charSpacer < 5 && charSpacer>0)) {
    var submitBtn = document.getElementById('addToCart-product-character-grid');
    submitBtn.disabled = true;
    submitBtn.innerText = "";
    submitBtn.classList.add("fiveminimums");
    submitBtn.classList.remove("minimums");
    submitBtn.style.backgroundColor="red";
    submitBtn.style.color="white";
    console.log("submit button disabled");
  } else if(totalCount >=5 && (charA > 4 || charA === 0) && (charB > 4 || charB === 0) && (charC > 4 || charC === 0) && (charD > 4 || charD === 0) && (charE > 4 || charE === 0) && (charF > 4 || charF === 0)
            && (charG > 4 || charG === 0) && (charH > 4 || charH === 0) && (charI > 4 || charI === 0) && (charJ > 4 || charJ === 0) && (charK > 4 || charK === 0) && (charL > 4 || charL === 0)
            && (charM > 4 || charM === 0) && (charN > 4 || charN === 0) && (charO > 4 || charO === 0) && (charP > 4 || charP === 0) && (charQ > 4 || charQ === 0) && (charR > 4 || charR === 0)
            && (charS > 4 || charS === 0) && (charT > 4 || charT === 0) && (charU > 4 || charU === 0) && (charV > 4 || charV === 0) && (charW > 4 || charW === 0) && (charX > 4 || charX === 0)
            && (charY > 4 || charY === 0) && (charZ > 4 || charZ === 0) && (char0 > 4 || char0 === 0) && (char1 > 4 || char1 === 0) && (char2 > 4 || char2 === 0) && (char3 > 4 || char3 === 0)
            && (char4 > 4 || char4 === 0) && (char5 > 4 || char5 === 0) && (char6 > 4 || char6 === 0) && (char7 > 4 || char7 === 0) && (char8 > 4 || char8 === 0) && (char9 > 4 || char9 === 0)
            && (charPeriod > 4 || charPeriod === 0) && (charComma > 4 || charComma === 0) && (charDash > 4 || charDash === 0) && (charSlash > 4 || charSlash === 0)
            && (charAmpersand > 4 || charAmpersand === 0) && (charSpacer > 4 || charSpacer === 0)){
    var submitBtn = document.getElementById('addToCart-product-character-grid');
    submitBtn.disabled = false;
    submitBtn.classList.remove("fiveminimums");
    submitBtn.classList.remove("minimums");
    submitBtn.innerText = "Add To Cart";
    submitBtn.style.color="white";
    submitBtn.style.backgroundColor="#49832e";
    console.log("submit button enabled");
  }
  } else {
    var submitBtn = document.getElementById('addToCart-product-character-grid');
      submitBtn.classList.remove("fiveminimums");
    submitBtn.classList.add("minimums");
  
     if (totalCount < 8) {
       var submitBtn = document.getElementById('addToCart-product-character-grid');
    submitBtn.disabled = true;
    submitBtn.innerText = "";
    submitBtn.classList.add("minimums");
    submitBtn.style.backgroundColor="red";
    submitBtn.style.color="white";
    console.log("submit button disabled");
  } else if (totalCount > 7) {
       var submitBtn = document.getElementById('addToCart-product-character-grid');
    submitBtn.disabled = false;
    submitBtn.classList.remove("minimums");
    submitBtn.innerText = "Add To Cart";
    submitBtn.style.color="white";
    submitBtn.style.backgroundColor="#49832e";
    console.log("submit button enabled");
  }
  }
  
  
  };
  
//wait for id of one character from group to be loaded then execute script
waitForElement("option_6917275025495_A", function(){
console.log("First Character Identified");

//define variables for characters
let charA = parseInt(document.getElementById('option_6917275025495_A').value);
let charB = parseInt(document.getElementById('option_6917275025495_B').value);
let charC = parseInt(document.getElementById('option_6917275025495_C').value);
let charD = parseInt(document.getElementById('option_6917275025495_D').value);
let charE = parseInt(document.getElementById('option_6917275025495_E').value);
let charF = parseInt(document.getElementById('option_6917275025495_F').value);
let charG = parseInt(document.getElementById('option_6917275025495_G').value);
let charH = parseInt(document.getElementById('option_6917275025495_H').value);
let charI = parseInt(document.getElementById('option_6917275025495_I').value);
let charJ = parseInt(document.getElementById('option_6917275025495_J').value);
let charK = parseInt(document.getElementById('option_6917275025495_K').value);
let charL = parseInt(document.getElementById('option_6917275025495_L').value);
let charM = parseInt(document.getElementById('option_6917275025495_M').value);
let charN = parseInt(document.getElementById('option_6917275025495_N').value);
let charO = parseInt(document.getElementById('option_6917275025495_O').value);
let charP = parseInt(document.getElementById('option_6917275025495_P').value);
let charQ = parseInt(document.getElementById('option_6917275025495_Q').value);
let charR = parseInt(document.getElementById('option_6917275025495_R').value);
let charS = parseInt(document.getElementById('option_6917275025495_S').value);
let charT = parseInt(document.getElementById('option_6917275025495_T').value);
let charU = parseInt(document.getElementById('option_6917275025495_U').value);
let charV = parseInt(document.getElementById('option_6917275025495_V').value);
let charW = parseInt(document.getElementById('option_6917275025495_W').value);
let charX = parseInt(document.getElementById('option_6917275025495_X').value);
let charY = parseInt(document.getElementById('option_6917275025495_Y').value);
let charZ = parseInt(document.getElementById('option_6917275025495_Z').value);
let char0 = parseInt(document.getElementById('option_6917275025495_0').value);
let char1 = parseInt(document.getElementById('option_6917275025495_1').value);
let char2 = parseInt(document.getElementById('option_6917275025495_2').value);
let char3 = parseInt(document.getElementById('option_6917275025495_3').value);
let char4 = parseInt(document.getElementById('option_6917275025495_4').value);
let char5 = parseInt(document.getElementById('option_6917275025495_5').value);
let char6 = parseInt(document.getElementById('option_6917275025495_6').value);
let char7 = parseInt(document.getElementById('option_6917275025495_7').value);
let char8 = parseInt(document.getElementById('option_6917275025495_8').value);
let char9 = parseInt(document.getElementById('option_6917275025495_9').value);
let charPeriod = parseInt(document.getElementById('option_6917275025495_Period').value);
let charComma = parseInt(document.getElementById('option_6917275025495_Comma').value);
let charDash = parseInt(document.getElementById('option_6917275025495_Dash').value);
let charSlash = parseInt(document.getElementById('option_6917275025495_Slash').value);
let charAmpersand = parseInt(document.getElementById('option_6917275025495_Ampersand').value);
let charSpacer = parseInt(document.getElementById('option_6917275025495_Spacer').value);

//define event listeners
const eventA = document.getElementById('option_6917275025495_A').addEventListener('change', selectA);
const eventB = document.getElementById('option_6917275025495_B').addEventListener('change', selectB);
const eventC = document.getElementById('option_6917275025495_C').addEventListener('change', selectC);
const eventD = document.getElementById('option_6917275025495_D').addEventListener('change', selectD);
const eventE = document.getElementById('option_6917275025495_E').addEventListener('change', selectE);
const eventF = document.getElementById('option_6917275025495_F').addEventListener('change', selectF);
const eventG = document.getElementById('option_6917275025495_G').addEventListener('change', selectG);
const eventH = document.getElementById('option_6917275025495_H').addEventListener('change', selectH);
const eventI = document.getElementById('option_6917275025495_I').addEventListener('change', selectI);
const eventJ = document.getElementById('option_6917275025495_J').addEventListener('change', selectJ);
const eventK = document.getElementById('option_6917275025495_K').addEventListener('change', selectK);
const eventL = document.getElementById('option_6917275025495_L').addEventListener('change', selectL);
const eventM = document.getElementById('option_6917275025495_M').addEventListener('change', selectM);
const eventN = document.getElementById('option_6917275025495_N').addEventListener('change', selectN);
const eventO = document.getElementById('option_6917275025495_O').addEventListener('change', selectO);
const eventP = document.getElementById('option_6917275025495_P').addEventListener('change', selectP);
const eventQ = document.getElementById('option_6917275025495_Q').addEventListener('change', selectQ);
const eventR = document.getElementById('option_6917275025495_R').addEventListener('change', selectR);
const eventS = document.getElementById('option_6917275025495_S').addEventListener('change', selectS);
const eventT = document.getElementById('option_6917275025495_T').addEventListener('change', selectT);
const eventU = document.getElementById('option_6917275025495_U').addEventListener('change', selectU);
const eventV = document.getElementById('option_6917275025495_V').addEventListener('change', selectV);
const eventW = document.getElementById('option_6917275025495_W').addEventListener('change', selectW);
const eventX = document.getElementById('option_6917275025495_X').addEventListener('change', selectX);
const eventY = document.getElementById('option_6917275025495_Y').addEventListener('change', selectY);
const eventZ = document.getElementById('option_6917275025495_Z').addEventListener('change', selectZ);
const event0 = document.getElementById('option_6917275025495_0').addEventListener('change', select0);
const event1 = document.getElementById('option_6917275025495_1').addEventListener('change', select1);
const event2 = document.getElementById('option_6917275025495_2').addEventListener('change', select2);
const event3 = document.getElementById('option_6917275025495_3').addEventListener('change', select3);
const event4 = document.getElementById('option_6917275025495_4').addEventListener('change', select4);
const event5 = document.getElementById('option_6917275025495_5').addEventListener('change', select5);
const event6 = document.getElementById('option_6917275025495_6').addEventListener('change', select6);
const event7 = document.getElementById('option_6917275025495_7').addEventListener('change', select7);
const event8 = document.getElementById('option_6917275025495_8').addEventListener('change', select8);
const event9 = document.getElementById('option_6917275025495_9').addEventListener('change', select9);
const eventPeriod = document.getElementById('option_6917275025495_Period').addEventListener('change', selectPeriod);
const eventComma = document.getElementById('option_6917275025495_Comma').addEventListener('change', selectComma);
const eventDash = document.getElementById('option_6917275025495_Dash').addEventListener('change', selectDash);
const eventSlash = document.getElementById('option_6917275025495_Slash').addEventListener('change', selectSlash);
const eventAmpersand = document.getElementById('option_6917275025495_Ampersand').addEventListener('change', selectAmpersand);
const eventSpacer = document.getElementById('option_6917275025495_Spacer').addEventListener('change', selectSpacer);

  
var submitBtn = document.getElementById('addToCart-product-character-grid');
submitBtn.disabled = true;
  
//functions

//disable mouse wheel increment when input field is focused
  $('input[type=number]').on('mousewheel', function(e) {
  $(e.target).blur();
});

//prevent deletion of values, non-recorded inputs, and keypresses which break the count
document.getElementById('option_6917275025495_A').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_A').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_A').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40 ) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_B').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_B').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_B').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_C').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_C').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_C').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});
  
document.getElementById('option_6917275025495_D').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_D').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_D').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});
  
document.getElementById('option_6917275025495_E').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_E').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_E').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_F').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_F').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_F').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_G').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_G').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_G').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_H').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_H').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_H').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_I').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_I').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_I').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_J').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_J').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_J').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_K').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_K').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_K').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_L').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_L').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_L').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_M').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_M').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_M').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_N').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_N').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_N').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_O').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_O').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_O').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_P').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_P').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_P').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_Q').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_Q').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_Q').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_R').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_R').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_R').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_S').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_S').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_S').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_T').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_T').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_T').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_U').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_U').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_U').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_V').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_V').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_V').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 8 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_W').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_W').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_W').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_X').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_X').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_X').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_Y').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_Y').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_Y').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_Z').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_Z').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_Z').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_0').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_0').setAttribute("pattern", "[0-9]*");
  
document.getElementById('option_6917275025495_0').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_1').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_1').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_1').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_2').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_2').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_2').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_3').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_3').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_3').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_4').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_4').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_4').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_5').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_5').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_5').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_6').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_6').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_6').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_7').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_7').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_7').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_8').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_8').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_8').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_9').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_9').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_9').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_Period').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_Period').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_Period').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_Comma').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_Comma').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_Comma').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_Dash').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_Dash').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_Dash').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_Slash').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_Slash').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_Slash').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        //console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

document.getElementById('option_6917275025495_Ampersand').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_Ampersand').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_Ampersand').addEventListener('keydown', function(event) {
 
    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        ////console.log("backspace or delete pressed");
        event.preventDefault()
    }
});


document.getElementById('option_6917275025495_Spacer').setAttribute("inputmode", "numeric");
document.getElementById('option_6917275025495_Spacer').setAttribute("pattern", "[0-9]*");

document.getElementById('option_6917275025495_Spacer').addEventListener('keydown', function(event) {

    var key = event.keyCode || event.charCode;

    if( key == 32 || key == 46 || key==81 || key == 87 || key == 69 || key == 82 || key == 84 ||
       key == 89 || key == 85 || key == 73 || key == 79 || key == 80 || key == 219 || key == 221 ||
       key == 220 || key == 189 || key == 187 || key == 65 || key == 83 || key == 68 || key == 70 ||
       key == 71 || key == 72 || key == 74 || key == 75 || key == 76 || key == 186 || key == 222 ||
       key == 90 || key == 88 || key == 67 || key == 86 || key == 66 || key == 78 || key == 77 ||
       key == 188 || key == 190 || key == 191 || key == 110 || key == 111 || key == 106 || key == 109 ||
       key == 107 || key == 13 || key == 9  || key == 38 || key == 40) {
        ////console.log("backspace or delete pressed");
        event.preventDefault()
    }
});

  
//event listener triggers (one for each character/number/sybmol)

  
function selectA(event) {
  let charA = parseInt(document.getElementById("option_6917275025495_A").value);
  let selectedA = document.getElementById("selected-characters").value;
  if (selectedA.search("A: ") > -1) {
 // console.log("A: is found");
  const selectFieldA = document.getElementById("selected-characters").value;
  const reg = /(A: )[A-Znan0-9]+[^A-Z]/g;
  let newAVal = selectFieldA.replace(reg, "A: " + charA + ",");
  document.getElementById("selected-characters").value = newAVal;
  } else if (selectedA.search("A: ") < 0) {
  let charA = parseInt(document.getElementById("option_6917275025495_A").value);
  let selectA = document.getElementById("selected-characters");
//  console.log("A: NOT found");
  selectA.value += " A: " + charA + ",";
  };
//  console.log("A was Clicked with value " + charA);
  addCounts();
};

function selectB(event) {

    let selectedB = document.getElementById("selected-characters").value;
    if (selectedB.search("B: ") > -1) {
   // console.log("B: is found");
    const selectFieldB = document.getElementById("selected-characters").value;
    const reg = /(B: )[A-Znan0-9]+[^A-Z]/g;
    let charB = parseInt(document.getElementById("option_6917275025495_B").value);
    let newBVal = selectFieldB.replace(reg, "B: " + charB + ",");
    document.getElementById("selected-characters").value = newBVal;
    } else if (selectedB.search("B: ") < 0) {
    let charB = parseInt(document.getElementById("option_6917275025495_B").value);
    let selectB = document.getElementById("selected-characters");
  //  console.log("B: NOT found");
    selectB.value += " B: " + charB + ",";
    };
  //  console.log("B was Clicked with value " + charB);
    addCounts();
  };

function selectC(event) {

    let selectedC = document.getElementById("selected-characters").value;
    if (selectedC.search("C: ") > -1) {
   // console.log("C: is found");
    const selectFieldC = document.getElementById("selected-characters").value;
    const reg = /(C: )[A-Znan0-9]+[^A-Z]/g;
    let charC = parseInt(document.getElementById("option_6917275025495_C").value);
    let newCVal = selectFieldC.replace(reg, "C: " + charC + ",");
    document.getElementById("selected-characters").value = newCVal;
    } else if (selectedC.search("C: ") < 0) {
    let charC = parseInt(document.getElementById("option_6917275025495_C").value);
    let selectC = document.getElementById("selected-characters");
  //  console.log("C: NOT found");
    selectC.value += " C: " + charC + ",";
    };
  //  console.log("C was Clicked with value " + charC);
    addCounts();
  };

function selectD(event) {

    let selectedD = document.getElementById("selected-characters").value;
    if (selectedD.search("D: ") > -1) {
   // console.log("D: is found");
    const selectFieldD = document.getElementById("selected-characters").value;
    const reg = /(D: )[A-Znan0-9]+[^A-Z]/g;
    let charD = parseInt(document.getElementById("option_6917275025495_D").value);
    let newDVal = selectFieldD.replace(reg, "D: " + charD + ",");
    document.getElementById("selected-characters").value = newDVal;
    } else if (selectedD.search("D: ") < 0) {
    let charD = parseInt(document.getElementById("option_6917275025495_D").value);
    let selectD = document.getElementById("selected-characters");
  //  console.log("D: NOT found");
    selectD.value += " D: " + charD + ",";
    };
  //  console.log("D was Clicked with value " + charD);
    addCounts();
  };

function selectE(event) {

    let selectedE = document.getElementById("selected-characters").value;
    if (selectedE.search("E: ") > -1) {
   // console.log("E: is found");
    const selectFieldE = document.getElementById("selected-characters").value;
    const reg = /(E: )[A-Znan0-9]+[^A-Z]/g;
    let charE = parseInt(document.getElementById("option_6917275025495_E").value);
    let newEVal = selectFieldE.replace(reg, "E: " + charE + ",");
    document.getElementById("selected-characters").value = newEVal;
    } else if (selectedE.search("E: ") < 0) {
    let charE = parseInt(document.getElementById("option_6917275025495_E").value);
    let selectE = document.getElementById("selected-characters");
  //  console.log("E: NOT found");
    selectE.value += " E: " + charE + ",";
    };
  //  console.log("E was Clicked with value " + charE);
    addCounts();
  };

function selectF(event) {

    let selectedF = document.getElementById("selected-characters").value;
    if (selectedF.search("F: ") > -1) {
   // console.log("F: is found");
    const selectFieldF = document.getElementById("selected-characters").value;
    const reg = /(F: )[A-Znan0-9]+[^A-Z]/g;
    let charF = parseInt(document.getElementById("option_6917275025495_F").value);
    let newFVal = selectFieldF.replace(reg, "F: " + charF + ",");
    document.getElementById("selected-characters").value = newFVal;
    } else if (selectedF.search("F: ") < 0) {
    let charF = parseInt(document.getElementById("option_6917275025495_F").value);
    let selectF = document.getElementById("selected-characters");
  //  console.log("F: NOT found");
    selectF.value += " F: " + charF + ",";
    };
  //  console.log("F was Clicked with value " + charF);
    addCounts();
  };

function selectG(event) {

    let selectedG = document.getElementById("selected-characters").value;
    if (selectedG.search("G: ") > -1) {
   // console.log("G: is found");
    const selectFieldG = document.getElementById("selected-characters").value;
    const reg = /(G: )[A-Znan0-9]+[^A-Z]/g;
    let charG = parseInt(document.getElementById("option_6917275025495_G").value);
    let newGVal = selectFieldG.replace(reg, "G: " + charG + ",");
    document.getElementById("selected-characters").value = newGVal;
    } else if (selectedG.search("G: ") < 0) {
    let charG = parseInt(document.getElementById("option_6917275025495_G").value);
    let selectG = document.getElementById("selected-characters");
  //  console.log("G: NOT found");
    selectG.value += " G: " + charG + ",";
    };
  //  console.log("G was Clicked with value " + charG);
    addCounts();
  };

function selectH(event) {

    let selectedH = document.getElementById("selected-characters").value;
    if (selectedH.search("H: ") > -1) {
   // console.log("H: is found");
    const selectFieldH = document.getElementById("selected-characters").value;
    const reg = /(H: )[A-Znan0-9]+[^A-Z]/g;
    let charH = parseInt(document.getElementById("option_6917275025495_H").value);
    let newHVal = selectFieldH.replace(reg, "H: " + charH + ",");
    document.getElementById("selected-characters").value = newHVal;
    } else if (selectedH.search("H: ") < 0) {
    let charH = parseInt(document.getElementById("option_6917275025495_H").value);
    let selectH = document.getElementById("selected-characters");
  //  console.log("H: NOT found");
    selectH.value += " H: " + charH + ",";
    };
  //  console.log("H was Clicked with value " + charH);
    addCounts();
  };

function selectI(event) {

    let selectedI = document.getElementById("selected-characters").value;
    if (selectedI.search("I: ") > -1) {
   // console.log("I: is found");
    const selectFieldI = document.getElementById("selected-characters").value;
    const reg = /(I: )[A-Znan0-9]+[^A-Z]/g;
    let charI = parseInt(document.getElementById("option_6917275025495_I").value);
    let newIVal = selectFieldI.replace(reg, "I: " + charI + ",");
    document.getElementById("selected-characters").value = newIVal;
    } else if (selectedI.search("I: ") < 0) {
    let charI = parseInt(document.getElementById("option_6917275025495_I").value);
    let selectI = document.getElementById("selected-characters");
  //  console.log("I: NOT found");
    selectI.value += " I: " + charI + ",";
    };
  //  console.log("I was Clicked with value " + charI);
    addCounts();
  };

function selectJ(event) {

    let selectedJ = document.getElementById("selected-characters").value;
    if (selectedJ.search("J: ") > -1) {
   // console.log("J: is found");
    const selectFieldJ = document.getElementById("selected-characters").value;
    const reg = /(J: )[A-Znan0-9]+[^A-Z]/g;
    let charJ = parseInt(document.getElementById("option_6917275025495_J").value);
    let newJVal = selectFieldJ.replace(reg, "J: " + charJ + ",");
    document.getElementById("selected-characters").value = newJVal;
    } else if (selectedJ.search("J: ") < 0) {
    let charJ = parseInt(document.getElementById("option_6917275025495_J").value);
    let selectJ = document.getElementById("selected-characters");
  //  console.log("J: NOT found");
    selectJ.value += " J: " + charJ + ",";
    };
  //  console.log("J was Clicked with value " + charJ);
    addCounts();
  };

  function selectK(event) {

    let selectedK = document.getElementById("selected-characters").value;
    if (selectedK.search("K: ") > -1) {
   // console.log("K: is found");
    const selectFieldK = document.getElementById("selected-characters").value;
    const reg = /(K: )[A-Znan0-9]+[^A-Z]/g;
    let charK = parseInt(document.getElementById("option_6917275025495_K").value);
    let newKVal = selectFieldK.replace(reg, "K: " + charK + ",");
    document.getElementById("selected-characters").value = newKVal;
    } else if (selectedK.search("K: ") < 0) {
    let charK = parseInt(document.getElementById("option_6917275025495_K").value);
    let selectK = document.getElementById("selected-characters");
  //  console.log("K: NOT found");
    selectK.value += " K: " + charK + ",";
    };
  //  console.log("K was Clicked with value " + charK);
    addCounts();
  };

function selectL(event) {

    let selectedL = document.getElementById("selected-characters").value;
    if (selectedL.search("L: ") > -1) {
   // console.log("L: is found");
    const selectFieldL = document.getElementById("selected-characters").value;
    const reg = /(L: )[A-Znan0-9]+[^A-Z]/g;
    let charL = parseInt(document.getElementById("option_6917275025495_L").value);
    let newLVal = selectFieldL.replace(reg, "L: " + charL + ",");
    document.getElementById("selected-characters").value = newLVal;
    } else if (selectedL.search("L: ") < 0) {
    let charL = parseInt(document.getElementById("option_6917275025495_L").value);
    let selectL = document.getElementById("selected-characters");
  //  console.log("L: NOT found");
    selectL.value += " L: " + charL + ",";
    };
  //  console.log("L was Clicked with value " + charL);
    addCounts();
  };

function selectM(event) {

    let selectedM = document.getElementById("selected-characters").value;
    if (selectedM.search("M: ") > -1) {
   // console.log("M: is found");
    const selectFieldM = document.getElementById("selected-characters").value;
    const reg = /(M: )[A-Znan0-9]+[^A-Z]/g;
    let charM = parseInt(document.getElementById("option_6917275025495_M").value);
    let newMVal = selectFieldM.replace(reg, "M: " + charM + ",");
    document.getElementById("selected-characters").value = newMVal;
    } else if (selectedM.search("M: ") < 0) {
    let charM = parseInt(document.getElementById("option_6917275025495_M").value);
    let selectM = document.getElementById("selected-characters");
  //  console.log("M: NOT found");
    selectM.value += " M: " + charM + ",";
    };
  //  console.log("M was Clicked with value " + charM);
    addCounts();
  };

function selectN(event) {

    let selectedN = document.getElementById("selected-characters").value;
    if (selectedN.search("N: ") > -1) {
   // console.log("N: is found");
    const selectFieldN = document.getElementById("selected-characters").value;
    const reg = /(N: )[A-Znan0-9]+[^A-Z]/g;
    let charN = parseInt(document.getElementById("option_6917275025495_N").value);
    let newNVal = selectFieldN.replace(reg, "N: " + charN + ",");
    document.getElementById("selected-characters").value = newNVal;
    } else if (selectedG.search("N: ") < 0) {
    let charN = parseInt(document.getElementById("option_6917275025495_N").value);
    let selectN = document.getElementById("selected-characters");
  //  console.log("N: NOT found");
    selectN.value += " N: " + charN + ",";
    };
  //  console.log("N was Clicked with value " + charN);
    addCounts();
  };

function selectO(event) {

    let selectedO = document.getElementById("selected-characters").value;
    if (selectedO.search("O: ") > -1) {
   // console.log("O: is found");
    const selectFieldO = document.getElementById("selected-characters").value;
    const reg = /(O: )[A-Znan0-9]+[^A-Z]/g;
    let charO = parseInt(document.getElementById("option_6917275025495_O").value);
    let newOVal = selectFieldO.replace(reg, "O: " + charO + ",");
    document.getElementById("selected-characters").value = newOVal;
    } else if (selectedO.search("O: ") < 0) {
    let charO = parseInt(document.getElementById("option_6917275025495_O").value);
    let selectO = document.getElementById("selected-characters");
  //  console.log("O: NOT found");
    selectO.value += " O: " + charO + ",";
    };
  //  console.log("O was Clicked with value " + charO);
    addCounts();
  };

function selectP(event) {

    let selectedP = document.getElementById("selected-characters").value;
    if (selectedP.search("P: ") > -1) {
   // console.log("P: is found");
    const selectFieldP = document.getElementById("selected-characters").value;
    const reg = /(P: )[A-Znan0-9]+[^A-Z]/g;
    let charP = parseInt(document.getElementById("option_6917275025495_P").value);
    let newPVal = selectFieldP.replace(reg, "P: " + charP + ",");
    document.getElementById("selected-characters").value = newPVal;
    } else if (selectedP.search("P: ") < 0) {
    let charP = parseInt(document.getElementById("option_6917275025495_P").value);
    let selectP = document.getElementById("selected-characters");
  //  console.log("P: NOT found");
    selectP.value += " P: " + charP + ",";
    };
  //  console.log("P was Clicked with value " + charP);
    addCounts();
  };

function selectQ(event) {

    let selectedQ = document.getElementById("selected-characters").value;
    if (selectedQ.search("Q: ") > -1) {
   // console.log("Q: is found");
    const selectFieldQ = document.getElementById("selected-characters").value;
    const reg = /(Q: )[A-Znan0-9]+[^A-Z]/g;
    let charQ = parseInt(document.getElementById("option_6917275025495_Q").value);
    let newQVal = selectFieldQ.replace(reg, "Q: " + charQ + ",");
    document.getElementById("selected-characters").value = newQVal;
    } else if (selectedQ.search("Q: ") < 0) {
    let charQ = parseInt(document.getElementById("option_6917275025495_Q").value);
    let selectQ = document.getElementById("selected-characters");
  //  console.log("Q: NOT found");
    selectQ.value += " Q: " + charQ + ",";
    };
  //  console.log("Q was Clicked with value " + charQ);
    addCounts();
  };

function selectR(event) {

    let selectedR = document.getElementById("selected-characters").value;
    if (selectedR.search("R: ") > -1) {
   // console.log("R: is found");
    const selectFieldR = document.getElementById("selected-characters").value;
    const reg = /(R: )[A-Znan0-9]+[^A-Z]/g;
    let charR = parseInt(document.getElementById("option_6917275025495_R").value);
    let newRVal = selectFieldR.replace(reg, "R: " + charR + ",");
    document.getElementById("selected-characters").value = newRVal;
    } else if (selectedR.search("R: ") < 0) {
    let charR = parseInt(document.getElementById("option_6917275025495_R").value);
    let selectR = document.getElementById("selected-characters");
  //  console.log("R: NOT found");
    selectR.value += " R: " + charR + ",";
    };
  //  console.log("R was Clicked with value " + charR);
    addCounts();
  };

function selectS(event) {

    let selectedS = document.getElementById("selected-characters").value;
    if (selectedS.search("S: ") > -1) {
   // console.log("S: is found");
    const selectFieldS = document.getElementById("selected-characters").value;
    const reg = /(S: )[A-Znan0-9]+[^A-Z]/g;
    let charS = parseInt(document.getElementById("option_6917275025495_S").value);
    let newSVal = selectFieldS.replace(reg, "S: " + charS + ",");
    document.getElementById("selected-characters").value = newSVal;
    } else if (selectedS.search("S: ") < 0) {
    let charS = parseInt(document.getElementById("option_6917275025495_S").value);
    let selectS = document.getElementById("selected-characters");
  //  console.log("S: NOT found");
    selectS.value += " S: " + charS + ",";
    };
  //  console.log("S was Clicked with value " + charS);
    addCounts();
  };

function selectT(event) {

    let selectedT = document.getElementById("selected-characters").value;
    if (selectedT.search("T: ") > -1) {
   // console.log("T: is found");
    const selectFieldT = document.getElementById("selected-characters").value;
    const reg = /(T: )[A-Znan0-9]+[^A-Z]/g;
    let charT = parseInt(document.getElementById("option_6917275025495_T").value);
    let newTVal = selectFieldT.replace(reg, "T: " + charT + ",");
    document.getElementById("selected-characters").value = newTVal;
    } else if (selectedT.search("T: ") < 0) {
    let charT = parseInt(document.getElementById("option_6917275025495_T").value);
    let selectT = document.getElementById("selected-characters");
  //  console.log("T: NOT found");
    selectT.value += " T: " + charT + ",";
    };
  //  console.log("T was Clicked with value " + charT);
    addCounts();
  };

function selectU(event) {

    let selectedU = document.getElementById("selected-characters").value;
    if (selectedU.search("U: ") > -1) {
   // console.log("U: is found");
    const selectFieldU = document.getElementById("selected-characters").value;
    const reg = /(U: )[A-Znan0-9]+[^A-Z]/g;
    let charU = parseInt(document.getElementById("option_6917275025495_U").value);
    let newUVal = selectFieldU.replace(reg, "U: " + charU + ",");
    document.getElementById("selected-characters").value = newUVal;
    } else if (selectedU.search("U: ") < 0) {
    let charU = parseInt(document.getElementById("option_6917275025495_U").value);
    let selectU = document.getElementById("selected-characters");
  //  console.log("U: NOT found");
    selectU.value += " U: " + charU + ",";
    };
  //  console.log("U was Clicked with value " + charU);
    addCounts();
  };

function selectV(event) {

    let selectedV = document.getElementById("selected-characters").value;
    if (selectedV.search("V: ") > -1) {
   // console.log("V: is found");
    const selectFieldV = document.getElementById("selected-characters").value;
    const reg = /(V: )[A-Znan0-9]+[^A-Z]/g;
    let charV = parseInt(document.getElementById("option_6917275025495_V").value);
    let newVVal = selectFieldV.replace(reg, "V: " + charV + ",");
    document.getElementById("selected-characters").value = newVVal;
    } else if (selectedV.search("V: ") < 0) {
    let charV = parseInt(document.getElementById("option_6917275025495_V").value);
    let selectV = document.getElementById("selected-characters");
  //  console.log("V: NOT found");
    selectV.value += " V: " + charV + ",";
    };
  //  console.log("V was Clicked with value " + charV);
    addCounts();
  };

function selectW(event) {

    let selectedW = document.getElementById("selected-characters").value;
    if (selectedW.search("W: ") > -1) {
   // console.log("W: is found");
    const selectFieldW = document.getElementById("selected-characters").value;
    const reg = /(W: )[A-Znan0-9]+[^A-Z]/g;
    let charW = parseInt(document.getElementById("option_6917275025495_W").value);
    let newWVal = selectFieldW.replace(reg, "W: " + charW + ",");
    document.getElementById("selected-characters").value = newWVal;
    } else if (selectedW.search("W: ") < 0) {
    let charW = parseInt(document.getElementById("option_6917275025495_W").value);
    let selectW = document.getElementById("selected-characters");
  //  console.log("W: NOT found");
    selectW.value += " W: " + charW + ",";
    };
  //  console.log("W was Clicked with value " + charW);
    addCounts();
  };

function selectX(event) {

    let selectedX = document.getElementById("selected-characters").value;
    if (selectedX.search("X: ") > -1) {
   // console.log("X: is found");
    const selectFieldX = document.getElementById("selected-characters").value;
    const reg = /(X: )[A-Znan0-9]+[^A-Z]/g;
    let charX = parseInt(document.getElementById("option_6917275025495_X").value);
    let newXVal = selectFieldX.replace(reg, "X: " + charX + ",");
    document.getElementById("selected-characters").value = newXVal;
    } else if (selectedX.search("X: ") < 0) {
    let charX = parseInt(document.getElementById("option_6917275025495_X").value);
    let selectX = document.getElementById("selected-characters");
  //  console.log("X: NOT found");
    selectX.value += " X: " + charX + ",";
    };
  //  console.log("X was Clicked with value " + charX);
    addCounts();
  };

function selectY(event) {

    let selectedY = document.getElementById("selected-characters").value;
    if (selectedY.search("Y: ") > -1) {
   // console.log("Y: is found");
    const selectFieldY = document.getElementById("selected-characters").value;
    const reg = /(Y: )[A-Znan0-9]+[^A-Z]/g;
    let charY = parseInt(document.getElementById("option_6917275025495_Y").value);
    let newYVal = selectFieldY.replace(reg, "Y: " + charY + ",");
    document.getElementById("selected-characters").value = newYVal;
    } else if (selectedY.search("Y: ") < 0) {
    let charY = parseInt(document.getElementById("option_6917275025495_Y").value);
    let selectY = document.getElementById("selected-characters");
  //  console.log("Y: NOT found");
    selectY.value += " Y: " + charY + ",";
    };
  //  console.log("Y was Clicked with value " + charY);
    addCounts();
  };

function selectZ(event) {

    let selectedZ = document.getElementById("selected-characters").value;
    if (selectedZ.search("Z: ") > -1) {
   // console.log("Z: is found");
    const selectFieldZ = document.getElementById("selected-characters").value;
    const reg = /(Z: )[A-Znan0-9]+[^A-Z]/g;
    let charZ = parseInt(document.getElementById("option_6917275025495_Z").value);
    let newZVal = selectFieldZ.replace(reg, "Z: " + charZ + ",");
    document.getElementById("selected-characters").value = newZVal;
    } else if (selectedZ.search("Z: ") < 0) {
    let charZ = parseInt(document.getElementById("option_6917275025495_Z").value);
    let selectZ = document.getElementById("selected-characters");
  //  console.log("Z: NOT found");
    selectZ.value += " Z: " + charZ + ",";
    };
  //  console.log("Z was Clicked with value " + charZ);
    addCounts();
  };

function select0(event) {

    let selected0 = document.getElementById("selected-characters").value;
    if (selected0.search("0: ") > -1) {
   // console.log("0: is found");
    const selectField0 = document.getElementById("selected-characters").value;
    const reg = /(0: )[A-Znan0-9]+[^A-Z]/g;
    let char0 = parseInt(document.getElementById("option_6917275025495_0").value);
    let new0Val = selectField0.replace(reg, "0: " + char0 + ",");
    document.getElementById("selected-characters").value = new0Val;
    } else if (selected0.search("0: ") < 0) {
    let char0 = parseInt(document.getElementById("option_6917275025495_0").value);
    let select0 = document.getElementById("selected-characters");
  //  console.log("0: NOT found");
    select0.value += " 0: " + char0 + ",";
    };
  //  console.log("0 was Clicked with value " + char0);
    addCounts();
  };

function select1(event) {

    let selected1 = document.getElementById("selected-characters").value;
    if (selected1.search("1: ") > -1) {
   // console.log("1: is found");
    const selectField1 = document.getElementById("selected-characters").value;
    const reg = /(1: )[A-Znan0-9]+[^A-Z]/g;
    let char1 = parseInt(document.getElementById("option_6917275025495_1").value);
    let new1Val = selectField1.replace(reg, "1: " + char1 + ",");
    document.getElementById("selected-characters").value = new1Val;
    } else if (selected1.search("1: ") < 0) {
    let char1 = parseInt(document.getElementById("option_6917275025495_1").value);
    let select1 = document.getElementById("selected-characters");
  //  console.log("1: NOT found");
    select1.value += " 1: " + char1 + ",";
    };
  //  console.log("1 was Clicked with value " + char1);
    addCounts();
  };

  function select2(event) {

    let selected2 = document.getElementById("selected-characters").value;
    if (selected2.search("2: ") > -1) {
   // console.log("2: is found");
    const selectField2 = document.getElementById("selected-characters").value;
    const reg = /(2: )[A-Znan0-9]+[^A-Z]/g;
    let char2 = parseInt(document.getElementById("option_6917275025495_2").value);
    let new2Val = selectField2.replace(reg, "2: " + char2 + ",");
    document.getElementById("selected-characters").value = new2Val;
    } else if (selected2.search("2: ") < 0) {
    let char2 = parseInt(document.getElementById("option_6917275025495_2").value);
    let select2 = document.getElementById("selected-characters");
  //  console.log("2: NOT found");
    select2.value += " 2: " + char2 + ",";
    };
  //  console.log("2 was Clicked with value " + char2);
    addCounts();
  };

function select3(event) {

    let selected3 = document.getElementById("selected-characters").value;
    if (selected3.search("3: ") > -1) {
   // console.log("3: is found");
    const selectField3 = document.getElementById("selected-characters").value;
    const reg = /(3: )[A-Znan0-9]+[^A-Z]/g;
    let char3 = parseInt(document.getElementById("option_6917275025495_3").value);
    let new3Val = selectField3.replace(reg, "3: " + char3 + ",");
    document.getElementById("selected-characters").value = new3Val;
    } else if (selected3.search("3: ") < 0) {
    let char3 = parseInt(document.getElementById("option_6917275025495_3").value);
    let select3 = document.getElementById("selected-characters");
  //  console.log("3: NOT found");
    select3.value += " 3: " + char3 + ",";
    };
  //  console.log("3 was Clicked with value " + char3);
    addCounts();
  };

function select4(event) {

    let selected4 = document.getElementById("selected-characters").value;
    if (selected4.search("4: ") > -1) {
   // console.log("4: is found");
    const selectField4 = document.getElementById("selected-characters").value;
    const reg = /(4: )[A-Znan0-9]+[^A-Z]/g;
    let char4 = parseInt(document.getElementById("option_6917275025495_4").value);
    let new4Val = selectField4.replace(reg, "4: " + char4 + ",");
    document.getElementById("selected-characters").value = new4Val;
    } else if (selected4.search("4: ") < 0) {
    let char4 = parseInt(document.getElementById("option_6917275025495_4").value);
    let select4 = document.getElementById("selected-characters");
  //  console.log("4: NOT found");
    select4.value += " 4: " + char4 + ",";
    };
  //  console.log("4 was Clicked with value " + char4);
    addCounts();
  };

  function select5(event) {

    let selected5 = document.getElementById("selected-characters").value;
    if (selected5.search("5: ") > -1) {
   // console.log("5: is found");
    const selectField5 = document.getElementById("selected-characters").value;
    const reg = /(5: )[A-Znan0-9]+[^A-Z]/g;
    let char5 = parseInt(document.getElementById("option_6917275025495_5").value);
    let new5Val = selectField5.replace(reg, "5: " + char5 + ",");
    document.getElementById("selected-characters").value = new5Val;
    } else if (selected5.search("5: ") < 0) {
    let char5 = parseInt(document.getElementById("option_6917275025495_5").value);
    let select5 = document.getElementById("selected-characters");
  //  console.log("5: NOT found");
    select5.value += " 5: " + char5 + ",";
    };
  //  console.log("5 was Clicked with value " + char5);
    addCounts();
  };

function select6(event) {

    let selected6 = document.getElementById("selected-characters").value;
    if (selected6.search("6: ") > -1) {
   // console.log("6: is found");
    const selectField6 = document.getElementById("selected-characters").value;
    const reg = /(6: )[A-Znan0-9]+[^A-Z]/g;
    let char6 = parseInt(document.getElementById("option_6917275025495_6").value);
    let new6Val = selectField6.replace(reg, "6: " + char6 + ",");
    document.getElementById("selected-characters").value = new6Val;
    } else if (selected6.search("6: ") < 0) {
    let char6 = parseInt(document.getElementById("option_6917275025495_6").value);
    let select6 = document.getElementById("selected-characters");
  //  console.log("6: NOT found");
    select6.value += " 6: " + char6 + ",";
    };
  //  console.log("6 was Clicked with value " + char6);
    addCounts();
  };

function select7(event) {

    let selected7 = document.getElementById("selected-characters").value;
    if (selected7.search("7: ") > -1) {
   // console.log("7: is found");
    const selectField7 = document.getElementById("selected-characters").value;
    const reg = /(7: )[A-Znan0-9]+[^A-Z]/g;
    let char7 = parseInt(document.getElementById("option_6917275025495_7").value);
    let new7Val = selectField7.replace(reg, "7: " + char7 + ",");
    document.getElementById("selected-characters").value = new7Val;
    } else if (selected7.search("7: ") < 0) {
    let char7 = parseInt(document.getElementById("option_6917275025495_7").value);
    let select7 = document.getElementById("selected-characters");
  //  console.log("7: NOT found");
    select7.value += " 7: " + char7 + ",";
    };
  //  console.log("7 was Clicked with value " + char7);
    addCounts();
  };

function select8(event) {

    let selected8 = document.getElementById("selected-characters").value;
    if (selected8.search("8: ") > -1) {
   // console.log("8: is found");
    const selectField8 = document.getElementById("selected-characters").value;
    const reg = /(8: )[A-Znan0-9]+[^A-Z]/g;
    let char8 = parseInt(document.getElementById("option_6917275025495_8").value);
    let new8Val = selectField8.replace(reg, "8: " + char8 + ",");
    document.getElementById("selected-characters").value = new8Val;
    } else if (selected8.search("8: ") < 0) {
    let char8 = parseInt(document.getElementById("option_6917275025495_8").value);
    let select8 = document.getElementById("selected-characters");
  //  console.log("8: NOT found");
    select8.value += " 8: " + char8 + ",";
    };
  //  console.log("8 was Clicked with value " + char8);
    addCounts();
  };

  function select9(event) {

    let selected9 = document.getElementById("selected-characters").value;
    if (selected9.search("9: ") > -1) {
   // console.log("9: is found");
    const selectField9 = document.getElementById("selected-characters").value;
    const reg = /(9: )[A-Znan0-9]+[^A-Z]/g;
    let char9 = parseInt(document.getElementById("option_6917275025495_9").value);
    let new9Val = selectField9.replace(reg, "9: " + char9 + ",");
    document.getElementById("selected-characters").value = new9Val;
    } else if (selected9.search("9: ") < 0) {
    let char9 = parseInt(document.getElementById("option_6917275025495_9").value);
    let select9 = document.getElementById("selected-characters");
  //  console.log("9: NOT found");
    select9.value += " 9: " + char9 + ",";
    };
  //  console.log("9 was Clicked with value " + char9);
    addCounts();
  };

function selectPeriod(event) {

    let selectedPeriod = document.getElementById("selected-characters").value;
    if (selectedPeriod.search(/\.: /) > -1) {
   // console.log(".: is found");
    const selectFieldPeriod = document.getElementById("selected-characters").value;
    const reg = /(\.: )[A-Znan0-9]+[^A-Z]/g;
    let charPeriod = parseInt(document.getElementById("option_6917275025495_Period").value);
    let newPeriodVal = selectFieldPeriod.replace(reg, ".: " + charPeriod + ",");
    document.getElementById("selected-characters").value = newPeriodVal;
    } else if (selectedPeriod.search(/\.: /) < 0) {
    let charPeriod = parseInt(document.getElementById("option_6917275025495_Period").value);
    let selectPeriod = document.getElementById("selected-characters");
  //  console.log(".: NOT found");
    selectPeriod.value += " .: " + charPeriod + ",";
    };
  //  console.log("Period was Clicked with value " + charPeriod);
    addCounts();
  };

function selectComma(event) {

    let selectedComma = document.getElementById("selected-characters").value;
    if (selectedComma.search(",: ") > -1) {
   // console.log(",: is found");
    const selectFieldComma = document.getElementById("selected-characters").value;
    const reg = /(,: )[A-Znan0-9]+[^A-Z]/g;
    let charComma = parseInt(document.getElementById("option_6917275025495_Comma").value);
    let newCommaVal = selectFieldComma.replace(reg, ",: " + charComma + ",");
    document.getElementById("selected-characters").value = newCommaVal;
    } else if (selectedComma.search(",: ") < 0) {
    let charComma = parseInt(document.getElementById("option_6917275025495_Comma").value);
    let selectComma = document.getElementById("selected-characters");
  //  console.log("Comma: NOT found");
    selectComma.value += " ,: " + charComma + ",";
    };
  //  console.log("Comma was Clicked with value " + charComma);
    addCounts();
  };

function selectDash(event) {

    let selectedDash = document.getElementById("selected-characters").value;
    if (selectedDash.search("-: ") > -1) {
   // console.log("-: is found");
    const selectFieldDash = document.getElementById("selected-characters").value;
    const reg = /(\-: )[A-Znan0-9]+[^A-Z]/g;
    let charDash = parseInt(document.getElementById("option_6917275025495_Dash").value);
    let newDashVal = selectFieldDash.replace(reg, "-: " + charDash + ",");
    document.getElementById("selected-characters").value = newDashVal;
    } else if (selectedDash.search("-: ") < 0) {
    let charDash = parseInt(document.getElementById("option_6917275025495_Dash").value);
    let selectDash = document.getElementById("selected-characters");
  //  console.log("Dash: NOT found");
    selectDash.value += " -: " + charDash + ",";
    };
  //  console.log("Dash was Clicked with value " + charDash);
    addCounts();
  };

function selectSlash(event) {

    let selectedSlash = document.getElementById("selected-characters").value;
    if (selectedSlash.search("/: ") > -1) {
   // console.log("/: is found");
    const selectFieldSlash = document.getElementById("selected-characters").value;
    const reg = /(\/: )[A-Znan0-9]+[^A-Z]/g;
    let charSlash = parseInt(document.getElementById("option_6917275025495_Slash").value);
    let newSlashVal = selectFieldSlash.replace(reg, "/: " + charSlash + ",");
    document.getElementById("selected-characters").value = newSlashVal;
    } else if (selectedSlash.search("/: ") < 0) {
    let charSlash = parseInt(document.getElementById("option_6917275025495_Slash").value);
    let selectSlash = document.getElementById("selected-characters");
  //  console.log("/: NOT found");
    selectSlash.value += " /: " + charSlash + ",";
    };
  //  console.log("Slash was Clicked with value " + charSlash);
    addCounts();
  };

function selectAmpersand(event) {

  let selectedAmpersand = document.getElementById("selected-characters").value;
  if (selectedAmpersand.search("&: ") > -1) {
 // console.log("&: is found");
  const selectFieldAmpersand = document.getElementById("selected-characters").value;
  const reg = /(&: )[A-Znan0-9]+[^A-Z]/g;
  let charAmpersand = parseInt(document.getElementById("option_6917275025495_Ampersand").value);
  let newAmpersandVal = selectFieldAmpersand.replace(reg, "&: " + charAmpersand + ",");
  document.getElementById("selected-characters").value = newAmpersandVal;
  } else if (selectedAmpersand.search("&: ") < 0) {
  let charAmpersand = parseInt(document.getElementById("option_6917275025495_Ampersand").value);
  let selectAmpersand = document.getElementById("selected-characters");
//  console.log("Ampersand: NOT found");
  selectAmpersand.value += " &: " + charAmpersand + ",";
  };
//  console.log("Ampersand was Clicked with value " + charAmpersand);
  addCounts();
};


function selectSpacer(event) {

  let selectedSpacer = document.getElementById("selected-characters").value;
  if (selectedSpacer.search("Spacer: ") > -1) {
 // console.log("Spacer: is found");
  const selectFieldSpacer = document.getElementById("selected-characters").value;
  const reg = /(Spacer: )[A-Znan0-9]+[^A-Z]/g;
  let charSpacer = parseInt(document.getElementById("option_6917275025495_Spacer").value);
  let newSpacerVal = selectFieldSpacer.replace(reg, "Spacer: " + charSpacer + ",");
  document.getElementById("selected-characters").value = newSpacerVal;
  } else if (selectedSpacer.search("Spacer: ") < 0) {
  let charSpacer = parseInt(document.getElementById("option_6917275025495_Spacer").value);
  let selectSpacer = document.getElementById("selected-characters");
//  console.log("Spacer: NOT found");
  selectSpacer.value += " Spacer: " + charSpacer + ",";
  };
//  console.log("Spacer was Clicked with value " + charSpacer);
  addCounts();
};
  

// addCounts function - check values and confirm minimum quantity has been reached
    function addCounts(){
  console.log("adding totals");
//redefine values from input fields    
let charA = parseInt(document.getElementById('option_6917275025495_A').value) || 0;
let charB = parseInt(document.getElementById('option_6917275025495_B').value) || 0;
let charC = parseInt(document.getElementById('option_6917275025495_C').value) || 0;
let charD = parseInt(document.getElementById('option_6917275025495_D').value) || 0;
let charE = parseInt(document.getElementById('option_6917275025495_E').value) || 0;
let charF = parseInt(document.getElementById('option_6917275025495_F').value) || 0;
let charG = parseInt(document.getElementById('option_6917275025495_G').value) || 0;
let charH = parseInt(document.getElementById('option_6917275025495_H').value) || 0;
let charI = parseInt(document.getElementById('option_6917275025495_I').value) || 0;
let charJ = parseInt(document.getElementById('option_6917275025495_J').value) || 0;
let charK = parseInt(document.getElementById('option_6917275025495_K').value) || 0;
let charL = parseInt(document.getElementById('option_6917275025495_L').value) || 0;
let charM = parseInt(document.getElementById('option_6917275025495_M').value) || 0;
let charN = parseInt(document.getElementById('option_6917275025495_N').value) || 0;
let charO = parseInt(document.getElementById('option_6917275025495_O').value) || 0;
let charP = parseInt(document.getElementById('option_6917275025495_P').value) || 0;
let charQ = parseInt(document.getElementById('option_6917275025495_Q').value) || 0;
let charR = parseInt(document.getElementById('option_6917275025495_R').value) || 0;
let charS = parseInt(document.getElementById('option_6917275025495_S').value) || 0;
let charT = parseInt(document.getElementById('option_6917275025495_T').value) || 0;
let charU = parseInt(document.getElementById('option_6917275025495_U').value) || 0;
let charV = parseInt(document.getElementById('option_6917275025495_V').value) || 0;
let charW = parseInt(document.getElementById('option_6917275025495_W').value) || 0;
let charX = parseInt(document.getElementById('option_6917275025495_X').value) || 0;
let charY = parseInt(document.getElementById('option_6917275025495_Y').value) || 0;
let charZ = parseInt(document.getElementById('option_6917275025495_Z').value) || 0;
let char0 = parseInt(document.getElementById('option_6917275025495_0').value) || 0;
let char1 = parseInt(document.getElementById('option_6917275025495_1').value) || 0;
let char2 = parseInt(document.getElementById('option_6917275025495_2').value) || 0;
let char3 = parseInt(document.getElementById('option_6917275025495_3').value) || 0;
let char4 = parseInt(document.getElementById('option_6917275025495_4').value) || 0;
let char5 = parseInt(document.getElementById('option_6917275025495_5').value) || 0;
let char6 = parseInt(document.getElementById('option_6917275025495_6').value) || 0;
let char7 = parseInt(document.getElementById('option_6917275025495_7').value) || 0;
let char8 = parseInt(document.getElementById('option_6917275025495_8').value) || 0;
let char9 = parseInt(document.getElementById('option_6917275025495_9').value) || 0;
let charPeriod = parseInt(document.getElementById('option_6917275025495_Period').value) || 0;
let charComma = parseInt(document.getElementById('option_6917275025495_Comma').value) || 0;
let charDash = parseInt(document.getElementById('option_6917275025495_Dash').value) || 0;
let charSlash = parseInt(document.getElementById('option_6917275025495_Slash').value) || 0;
let charAmpersand = parseInt(document.getElementById('option_6917275025495_Ampersand').value) || 0;
let charSpacer = parseInt(document.getElementById('option_6917275025495_Spacer').value) || 0;

      
let totalCount = charA + charB + charC + charD + charE + charF + charG +
  charH + charI + charJ + charK + charL + charM + charN + charO + charP +
  charQ + charR + charS + charT + charU + charV + charW + charX + charY +
  charZ + char0 + char1 + char2 + char3 + char4 + char5 + char6 + char7 +
  char8 + char9 + charPeriod + charComma + charDash + charSlash + charAmpersand + charSpacer;
      
  console.log(totalCount);

var charHeight = document.getElementById('option_6917275025495_charHeight').value;
      if (charHeight == "3/8 (10mm)") {
console.log("char height is"+charHeight);
var submitBtn = document.getElementById('addToCart-product-character-grid');
        
  if ((charA < 5 && charA>0) || (charB < 5 && charB>0) || (charC < 5 && charC>0) || (charD < 5 && charD>0) || (charE < 5 && charE>0) || (charF < 5 && charF>0) || (charG < 5 && charG>0) || (charH < 5 && charH>0)
     || (charI < 5 && charI>0) || (charJ < 5 && charJ>0) || (charK < 5 && charK>0) || (charL < 5 && charL>0) || (charM < 5 && charM>0) || (charN < 5 && charN>0) || (charO < 5 && charO>0) || (charP < 5 && charP>0)
     || (charQ < 5 && charQ>0) || (charR < 5 && charR>0) || (charS < 5 && charS>0) || (charT < 5 && charT>0) || (charU < 5 && charU>0) || (charV < 5 && charV>0) || (charW < 5 && charW>0) || (charX < 5 && charX>0)
     || (charY < 5 && charY>0) || (charZ < 5 && charZ>0) || (char0 < 5 && char0>0) || (char1 < 5 && char1>0) || (char2 < 5 && char2>0) || (char3 < 5 && char3>0) || (char4 < 5 && char4>0) || (char5 < 5 && char5>0)
     || (char6 < 5 && char6>0) || (char7 < 5 && char7>0) || (char8 < 5 && char8>0) || (char9 < 5 && char9>0) || (charPeriod < 5 && charPeriod>0) || (charComma < 5 && charComma>0) || (charDash < 5 && charDash>0)
     || (charSlash < 5 && charSlash>0) || (charAmpersand < 5 && charAmpersand>0) || (charSpacer < 5 && charSpacer>0)) {
    submitBtn.disabled = true;
    submitBtn.innerText = "";
    submitBtn.classList.add("fiveminimums");
    submitBtn.classList.remove("minimums");
    submitBtn.style.backgroundColor="red";
    submitBtn.style.color="white";
    console.log("submit button disabled");
  } else if(totalCount >=5 && (charA > 4 || charA === 0) && (charB > 4 || charB === 0) && (charC > 4 || charC === 0) && (charD > 4 || charD === 0) && (charE > 4 || charE === 0) && (charF > 4 || charF === 0)
            && (charG > 4 || charG === 0) && (charH > 4 || charH === 0) && (charI > 4 || charI === 0) && (charJ > 4 || charJ === 0) && (charK > 4 || charK === 0) && (charL > 4 || charL === 0)
            && (charM > 4 || charM === 0) && (charN > 4 || charN === 0) && (charO > 4 || charO === 0) && (charP > 4 || charP === 0) && (charQ > 4 || charQ === 0) && (charR > 4 || charR === 0)
            && (charS > 4 || charS === 0) && (charT > 4 || charT === 0) && (charU > 4 || charU === 0) && (charV > 4 || charV === 0) && (charW > 4 || charW === 0) && (charX > 4 || charX === 0)
            && (charY > 4 || charY === 0) && (charZ > 4 || charZ === 0) && (char0 > 4 || char0 === 0) && (char1 > 4 || char1 === 0) && (char2 > 4 || char2 === 0) && (char3 > 4 || char3 === 0)
            && (char4 > 4 || char4 === 0) && (char5 > 4 || char5 === 0) && (char6 > 4 || char6 === 0) && (char7 > 4 || char7 === 0) && (char8 > 4 || char8 === 0) && (char9 > 4 || char9 === 0)
            && (charPeriod > 4 || charPeriod === 0) && (charComma > 4 || charComma === 0) && (charDash > 4 || charDash === 0) && (charSlash > 4 || charSlash === 0)
            && (charAmpersand > 4 || charAmpersand === 0) && (charSpacer > 4 || charSpacer === 0)){
    submitBtn.disabled = false;
    submitBtn.classList.remove("fiveminimums");
    submitBtn.classList.remove("minimums");
    submitBtn.innerText = "Add To Cart";
    submitBtn.style.color="white";
    submitBtn.style.backgroundColor="#49832e";
    console.log("submit button enabled");
  }
        
      } else {
var submitBtn = document.getElementById('addToCart-product-character-grid');
  if (totalCount < 8) {
    submitBtn.disabled = true;
    submitBtn.innerText = "";
    submitBtn.classList.add("minimums");
    submitBtn.style.backgroundColor="red";
    submitBtn.style.color="white";
    console.log("submit button disabled");
  } else if (totalCount > 7) {
    submitBtn.disabled = false;
    submitBtn.classList.remove("minimums");
    submitBtn.innerText = "Add To Cart";
    submitBtn.style.color="white";
    submitBtn.style.backgroundColor="#49832e";
    console.log("submit button enabled");
  }
};

  
  };
  
})});

